/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_COMPANY(state, item) {
		state.resources.unshift(item);
	},
	SET_DATA_SELECTS(state, data) {
		state.dataSelectVisitPoint = data;
	},
	SET_CITIES(state, data) {
		state.cities = data;
	},
	SET_COUNTRIES(state, data) {
		state.countries = data;
	},
	SET_COUNTRIES_SITIDATA(state, data) {
		state.countries_sitidata = data;
	},
	SET_DEPARTMENTS(state, data) {
		state.departments = data;
	},
	REMOVE_RESOURCE(state, itemId) {
		const ItemIndex = state.resources.findIndex((p) => p.id === itemId);
		state.resources.splice(ItemIndex, 1);
	},
	// categories
	SET_CATEGORIES(state, categories) {
		//state.categories = categories
	},
	// categories
	SET_ROLES_STATUS_CATEGORIES_TYPOLOGIES(state, data) {
		const {role, status, category, typology} = data;
		state.role = role ? role : [];
		state.status = status ? status : [];
		state.category = category ? category : [];
		state.typology = typology ? typology : [];
	},
};
